import { useState, useEffect } from 'react';
import { BpmService } from '../../../../core/services/BpmService';

interface Props {
    idSelector: number;
    onChange: any;
    idJsonServiceClass: number;
}

export const SelectorJson = ({ idJsonServiceClass, idSelector, onChange }: Props) => {

    const service = new BpmService();
    const [lista, setLista] = useState([]);
    const [id, setID] = useState(0);

    useEffect(() => {
        getLista();
    }, [idJsonServiceClass])

    useEffect(() => {
        if(idSelector)
        {
            setID(idSelector);
        }
    }, [idSelector])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(parseInt(e));
    }

    const getLista = () => {
        service.getJsonServiceCatalog(idJsonServiceClass).subscribe(
            (resp: any) => {
                
                if (resp.DataBeanProperties.ObjectValue) {
                    setLista(resp.DataBeanProperties.ObjectValue);
                }
               
            }
        );
    }

    return (
        <>
            <label className='mb-2'>Servicio</label>
            <select className="form-control" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={null}>...</option>
                {lista &&
                    lista.map((item: any) => {
                        return (
                            <>
                                <option key={item.DataBeanProperties.IDJsonService} value={item.DataBeanProperties.IDJsonService} >{item.DataBeanProperties.Name}</option>
                            </>)
                    })
                }
            </select>
        </>
    )
}